window.site = (window.site || {});

/**
 * Init Hall Item Galleries slider with Swiper
 * @class HallItemGalleries
 * @static
 */
site.HallItemGalleries = (function HallItemGalleries() {

  'use strict';

  var inited = false;

  function initSwiper(container) {
    if (!container) return null;

    const images = Array.from(container.querySelectorAll('img'));
    if (images.length === 0) return null;

    // Create Swiper structure
    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    images.forEach((img) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(img.cloneNode(true));
      wrapper.appendChild(slide);
    });

    // Clear container
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    container.classList.add('swiper');
    container.appendChild(wrapper);

    // Add navigation
    const prevBtn = document.createElement('div');
    prevBtn.className = 'swiper-button-prev';
    container.appendChild(prevBtn);

    const nextBtn = document.createElement('div');
    nextBtn.className = 'swiper-button-next';
    container.appendChild(nextBtn);

    // Add pagination
    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    container.appendChild(pagination);

    return new window.Swiper(container, {
      modules: [window.SwiperModules.Navigation, window.SwiperModules.Pagination],
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
  }

  var init = function () {
    if (inited) return false;
    inited = true;

    const $hallItems = document.querySelectorAll('.hall-item');

    $hallItems.forEach(($hallItem) => {
      const $slider = $hallItem.querySelector('.hall-item-images');
      if ($slider) {
        const images = $slider.querySelectorAll('img');
        if (images.length > 1) {
          initSwiper($slider);
        }
      }
    });

    return true;
  };

  return {
    init: init,
  };

}());
